module.exports = __webpack_public_path__ + "img/052.d52389d7.png";